import React from 'react';
import { Link } from 'react-router-dom';

import PublicLayout from './common/PublicLayout';

function NotFound() {
  return (
    <PublicLayout>
      <div className="max-w-2xl mx-auto text-center">
        <div className="bg-hdlcc-darkGray rounded-lg p-8 shadow-md">
          <h1 className="text-6xl font-bold text-hdlcc-lightBlue mb-4">404</h1>
          <h2 className="text-2xl font-bold text-white mb-4">Page Not Found</h2>
          <p className="text-gray-400 mb-8">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block bg-hdlcc-lightBlue text-white px-6 py-3 rounded hover:bg-hdlcc-blue"
            >
              Go to Home
            </Link>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}

export default NotFound;
